export default __webpack_public_path__ + "static/media/311.ec527f58.png";